const Styles = {
  typography: {
    color: "#171B5E",
    marginBottom: 25,
    fontSize: 28,
    fontWeight: 500,
  },

  customTextFieldName: {
    width: "100%",
    marginBottom: "10px",
  },

  customTextFieldSecondary: {
    width: "85%",
    marginBottom: "10px",
  },
  customTextFieldSecondarytwo: {
    width: "85%",
    marginBottom: "10px",
    marginLeft: "40px",
  },
  gridContainerStyle: {
    marginTop: 8,
  },

  gridStyle: {
    marginTop: 12,
  },

  typographyRadio: {
    fontSize: 14,
    position: "relative",
    color: " #000000",
    fontWeight: 700,
  },

  countryLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "#8F92A1",
    padding: "5px 15px",
  },

  radioButtonStyle: {
    color: "#FF0000",
    "&.Mui-checked": {
      color: "#FF0000",
    },
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
  },
  name: {
    gridColumn: "1 / 3",
  },
};

export default Styles;
